import {useSyncExternalStore} from 'react'
import posthog from 'posthog-js'

import {POSTHOG_FEATURE_IS_GRAPEVYNE_TEAM} from '#/lib/posthog/flags'
import * as env from '#/env'

function subscribe(onStoreChange: () => void) {
  if (!env.POSTHOG_API_KEY) {
    return () => {}
  }
  return posthog.onFeatureFlags(() => {
    onStoreChange()
  })
}

function getSnapshot() {
  if (!env.POSTHOG_API_KEY) {
    return false
  }
  return posthog.isFeatureEnabled(POSTHOG_FEATURE_IS_GRAPEVYNE_TEAM) === true
}

function getServerSnapshot() {
  return false
}

/**
 * Whether the current user is in the GrapeVyne team cohort via PostHog.
 * Returns false when PostHog is not configured or the flag is off.
 */
export function useIsGrapeVyneTeam() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
